import React, { useState } from 'react';
import Axios from '../../Components/Axios/Axios';
import Auth from '../../Components/Auth/Auth';
import Cookies from 'js-cookie';
import { USER_KEY } from '../../Constants/index';
import { useHistory } from 'react-router-dom';
import { Grid, Paper, TextField, InputAdornment, Button } from '@mui/material';
import logo from '../../Images/logo_name.png';
import PersonIcon from '@mui/icons-material/Person';
import KeyIcon from '@mui/icons-material/Key';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

function Login() {
  // For History
  const history = useHistory();

  // For Set Style Paper
  const paperStyle = { padding: 20, width: 600, margin: 'auto' }

  // For Get Value from Username
  const [forUsername, setforUsername] = useState("");
  const username = (e) => {
    const result = e.target.value
    setforUsername(result)
  }

  // For Get Value from Password
  const [forPassword, setforPassword] = useState("");
  const password = (e) => {
    const result = e.target.value
    setforPassword(result)
  }

  // For Hide/Open Eye Password
  const [passwordEye, setPasswordEye] = useState(false);
  const eyeClick = () => {
    setPasswordEye(!passwordEye);
  }

  // For Hidden Any Alert
  const [alertLogin, setAlertLogin] = useState(false);

  // For Login Function
  const Login = async () => {
    if (forUsername != "" && forPassword != "") {
      await Axios.post('/Authenticate/Login', {
        username: forUsername,
        password: forPassword
      })
        .then(function (response) {
          if (response.data.login_code == '200') {
            setAlertLogin(false)
            Auth.login(() => {
              localStorage.setItem(USER_KEY, JSON.stringify(response.data));
              Cookies.set("CS_Staff_token", response.data.token);
              history.push('/home');
            })
          } else {
            setAlertLogin(true)
          }
        })
        .catch(function (error) {
          console.log(error);
        })
    }
  }

  return (
    <>
      <div className='login_bg'>
        <Grid className='login_con'>
          <Paper elevation={10} style={paperStyle} className='login_paper'>
            <Grid container className='login_grid_logo'>
              <img src={logo} width='300' />
            </Grid>

            <div className='login_welcome'>ຍິນດີຕ້ອນຮັບ</div>

            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <hr className='login_line_hr' />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            <Grid container className='login_tab_label'>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <span className='login_label'>ລະຫັດພະນັກງານ:</span>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <TextField
                  autoComplete='off'
                  className='form-control mt-1'
                  id="input-with-icon-textfield"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                  size='small'
                  variant='outlined'
                  fullWidth
                  onChange={username}
                />
              </Grid>
            </Grid>

            <Grid container className='login_tab_label'>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <span className='login_label'>ລະຫັດຜ່ານ:</span>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <TextField
                  autoComplete='off'
                  className='form-control mt-1'
                  id='input-with-icon-textfield'
                  type={(passwordEye === false) ? 'password' : 'text'}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <KeyIcon />
                      </InputAdornment>
                    ),

                    endAdornment: (
                      <InputAdornment position="end">
                        {(passwordEye === false) ? <VisibilityOffIcon onClick={eyeClick} /> : <RemoveRedEyeIcon onClick={eyeClick} />}
                      </InputAdornment>
                    ),
                  }}
                  size='small'
                  variant="outlined"
                  fullWidth
                  onChange={password}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            {alertLogin == true ? <>
              <Grid container className='login_tab_label'>
                <Grid item xs={2}></Grid>
                <Grid item xs={8}>
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <Alert variant="outlined" severity="warning">
                      <span className='login_alert'>Username or Password Incorrect !</span>
                    </Alert>
                  </Stack>
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
            </> : <></>}

            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <Button className='login_submit_button' fullWidth variant="outlined" onClick={Login}>ເຂົ້າສູ່ລະບົບ</Button>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            <Grid container className='login_tab_reset'>
              <Grid item xs={2}></Grid>
              <Grid item xs={8}>
                <span className='login_reset'>ລືມລະຫັດຜ່ານ ? <a href='/reset/password' className='login_reset_link'>ກົດບ່ອນນີ້ເພື່ອປ່ຽນລະຫັດຜ່ານ</a></span>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

          </Paper>
        </Grid>
      </div>
    </>
  )
}

export default Login